/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { useState } from 'react';

import { debounce } from 'lodash';

import { MultiSelect, Search } from '@coursera/cds-core';

import AddStaffButton from 'bundles/staff-management/src/cds/AddStaffButton';
import type { StatusFilter } from 'bundles/staff-management/src/cds/StaffTable/types';

import _t from 'i18n!nls/staff-management';

const styles = {
  container: css`
    display: flex;
    align-items: center;
    gap: var(--cds-spacing-200);
  `,
  search: css`
    max-width: 328px;
    flex-grow: 1;
  `,
  addStaffButtonContainer: css`
    margin-left: auto;
  `,
};

export const CDSTableHeader = ({
  onSearchChange,
  placeholder,
  statusFilter,
  setStatusFilter,
  roleFilterOptions = [],
  roleFilters,
  onRoleFiltersChange,
  ...props
}: {
  onSearchChange: (searchText: string) => void;
  placeholder: string;
  statusFilter: StatusFilter[];
  setStatusFilter: (statusFilter: StatusFilter[]) => void;
  roleFilterOptions?: {
    value: string | number;
    label: string;
  }[];
  roleFilters: string[];
  onRoleFiltersChange: (roleFilters: string[]) => void;
}) => {
  const [searchText, setSearchText] = useState('');

  const setSearchChange = debounce((searchQuery: string) => {
    onSearchChange(searchQuery);
  }, 200);

  const handleSearchChange = (searchQuery: string) => {
    setSearchText(searchQuery);
    setSearchChange(searchQuery);
  };

  return (
    <div css={styles.container} {...props}>
      <Search
        onChange={handleSearchChange}
        placeholder={placeholder}
        value={searchText}
        hideSearchButton
        fullWidth
        css={styles.search}
      />
      {roleFilterOptions.length > 0 && (
        <MultiSelect
          placeholder={_t('Role')}
          value={roleFilters}
          onChange={(value) => onRoleFiltersChange(Array.from(value) as string[])}
          variant="silent"
        >
          {roleFilterOptions.map((option) => (
            <MultiSelect.Option key={option.value}>{option.label}</MultiSelect.Option>
          ))}
        </MultiSelect>
      )}
      <MultiSelect
        placeholder={_t('Status')}
        value={statusFilter}
        onChange={(value) => setStatusFilter(Array.from(value) as StatusFilter[])}
        variant="silent"
      >
        <MultiSelect.Option key="active">{_t('Active')}</MultiSelect.Option>
        <MultiSelect.Option key="pending">{_t('Pending invite')}</MultiSelect.Option>
      </MultiSelect>

      <div css={styles.addStaffButtonContainer}>
        <AddStaffButton />
      </div>
    </div>
  );
};
